import { useContext, useMemo } from "react";
import { createMuiTheme } from "@material-ui/core";
import { WebContext } from "../Utility";
import { LOCAL_STORAGE_THEME_KEY } from "../Constants";
import useLocalStorage from "./useLocalStorage";
import getTemplateType from "../commonUtility/templateType";
import defineThemeEngine from "../commonUtility/defineThemeEngine";
import { compareThemes } from "../commonUtility/compareSameTheme";

const useAppTheme = () => {
  const { memberProfile: memberData } = useContext(WebContext);

  const { getItem, setItem } = useLocalStorage();

  const finalAppTheme = useMemo(() => {
    let theme = null;
    const templateType = getTemplateType(memberData);
    if (!templateType.templateTheme) {
      theme = createMuiTheme(defineThemeEngine(templateType));
    } else {
      const localStorageStoredTheme = getItem(LOCAL_STORAGE_THEME_KEY);
      if (localStorageStoredTheme) {
        const isThemeSame = compareThemes(
          localStorageStoredTheme,
          templateType.templateTheme
        );

        if (isThemeSame) {
          theme = createMuiTheme(
            defineThemeEngine({ templateTheme: localStorageStoredTheme })
          );
        } else {
          theme = createMuiTheme(defineThemeEngine(templateType));
          setItem(LOCAL_STORAGE_THEME_KEY, templateType.templateTheme);
        }
      } else {
        theme = createMuiTheme(defineThemeEngine(templateType));
        setItem(LOCAL_STORAGE_THEME_KEY, templateType.templateTheme);
      }
    }
    return theme;
  }, [memberData]);

  return [finalAppTheme];
};

export default useAppTheme;
